<app-tabs>
  <app-customer-service-tab />
</app-tabs>

